<template>
  <div class="chat-box">
	  <div class="chat-menu-container">
		  <chat-menu ref="chatMenu"></chat-menu>
	  </div>
	  <div class="chat-content">
		  <keep-alive>
		  	<router-view v-if="$route.meta.keepAlive" @compute-not-read="computeNotRead($event)"></router-view>
		  </keep-alive>
		  <router-view v-if="!$route.meta.keepAlive"></router-view>
	  </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ChatMenu from '@/components/ChatMenu.vue'

export default {
  name: 'ChatHome',
  components: {
    ChatMenu
  },
  methods:{
	  computeNotRead(){
		  this.$refs.chatMenu.reloadCount()
	  }
  }
}
</script>

<style>
	.chat-box{
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: relative;
	}
	.chat-box .chat-menu-container{
		width: 80px;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
	}
	.chat-box .chat-content{
		position: absolute;
		top: 0;
		left: 80px;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}
</style>
